import React, { useEffect, useMemo, useRef } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import PropTypes from 'prop-types'

import { AuthContext } from '../../contexts'
import { REFRESH_ACCESS_TOKEN, SET_USER } from '../../graphql/mutations'
import { GET_USER } from '../../graphql/queries'
import {
  createSession,
  decodeToken,
  getRefreshToken,
  getUser,
} from '../../services'

const AuthProvider = ({ children }) => {
  const { data } = useQuery(GET_USER)

  const isInitialized = useRef(false)
  const contextValue = useMemo(
    () => ({ user: (data && data.user) || getUser() }),
    [data],
  )

  const refreshToken = getRefreshToken()
  const [setUser] = useMutation(SET_USER)

  const [refreshAccessToken] = useMutation(REFRESH_ACCESS_TOKEN, {
    onCompleted({ refreshAccessToken: accessToken }) {
      const user = decodeToken(accessToken)
      createSession(user, accessToken, refreshToken)
      setUser({ variables: { user } })
    },
  })

  useEffect(() => {
    if (refreshToken && !isInitialized.current) {
      refreshAccessToken({ variables: { refreshToken } })
      isInitialized.current = true
    }
  }, [refreshToken, refreshAccessToken])

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  )
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export default AuthProvider
